import { create } from 'zustand'

export const useSongsStore = create(set => ({
  searchTerm: '',
  inputValue: '',
  setSearchTerm: newText => set({ searchTerm: newText }),
  setInputValue: newText => set({ inputValue: newText }),
  options: [
    { id: 'recent', text: 'last updated' },
    { id: 'published', text: 'published date' },
    { id: 'alpha', text: 'A-Z' },
  ],
  selectedOption: { id: 'recent', text: 'last updated' },
  setSelectedOption: newOption => set({ selectedOption: newOption }),
  syncOptions: [
    { id: 'all', text: 'all' },
    { id: 'true', text: 'synced' },
    { id: 'false', text: 'unsynced' },
  ],
  selectedSyncOption: { id: 'all', text: 'all' },
  setSelectedSyncOption: newOption => set({ selectedSyncOption: newOption }),
}))